module.exports = __webpack_public_path__ + "img/overlay-combat.51dd9cfc.png";